interface DataObject {
  currentValue: number | null | undefined;
  maxLength: number;
}

export function deleteSymbols(
  e: KeyboardEvent,
  priceInput: boolean,
  dataObj?: DataObject
): boolean {
  const invalidKeys = ['e', '-', '+', 'E'];
  const controlKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Control',
    'Meta',
  ];

  if (controlKeys.includes(e.key)) {
    return true;
  }

  if (
    (e.ctrlKey || e.metaKey) &&
    (e.key === 'c' || e.key === 'v' || e.key === 'x')
  ) {
    return true;
  }

  if (
    (!priceInput && e.key.length === 1 && !/[0-9]/.test(e.key)) || // Только цифры, если priceInput === false
    (priceInput && e.key.length === 1 && !/[0-9.,]/.test(e.key)) // Цифры, точка и запятая, если priceInput === true
  ) {
    e.preventDefault();
    return false;
  }

  if (dataObj && dataObj.currentValue && dataObj.maxLength) {
    if (
      String(dataObj.currentValue).length >= dataObj.maxLength ||
      String(dataObj.currentValue).startsWith('0')
    ) {
      e.preventDefault();
    }
  }
}
